import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Checkbox, Typography } from 'antd'

const ScmFinishedOrderRender = ({
  saving,
  scmFinishedOrder,
  scmPurchaseOrderCompleted,
  errors
}) => {
  const { i18n } = useTranslation()

  // Once both SCM boxes are checked the order has been emitted to osh-account
  // and can no longer be edited, so neither box may be unchecked.
  const bothChecked = scmFinishedOrder.checked && scmPurchaseOrderCompleted.checked

  return (
    <React.Fragment>
      <Checkbox
        onChange={scmFinishedOrder.onChange}
        checked={scmFinishedOrder.checked}
        disabled={saving || bothChecked}>
        {i18n.t('orders:scmFinishedOrder')}
      </Checkbox>
      <Checkbox
        onChange={scmPurchaseOrderCompleted.onChange}
        checked={scmPurchaseOrderCompleted.checked}
        style={{ margin: '0' }}
        disabled={saving || bothChecked}>
        {i18n.t('orders:scmPurchaseOrderCompleted')}
      </Checkbox>
      <Typography.Text type="danger">
        {errors.map(error => <div key={error}>{error}</div>)}
      </Typography.Text>
    </React.Fragment>
  )
}

const checkboxShape = PropTypes.shape({
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired
})

ScmFinishedOrderRender.propTypes = {
  saving: PropTypes.bool.isRequired,
  scmFinishedOrder: checkboxShape.isRequired,
  scmPurchaseOrderCompleted: checkboxShape.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired
}

ScmFinishedOrderRender.defaultProps = {}

export default ScmFinishedOrderRender
